import ElectronHelper from 'src/common/electron/ElectronHelper';
import { RetailElectronAPI } from 'src/common/electron/RetailElectronAPI';
import { ScaleState } from 'src/common/interfaces/states/ScaleState';

export const getIsManualWeightDisabled = (returnMode: boolean, scale: ScaleState) => {
  const { REACT_APP_ENABLE_MANUAL_WEIGHT_FOR_SALES } = ElectronHelper.isElectron()
    ? RetailElectronAPI.getEnvironmentVariables()
    : process.env;
  const scaleIsZeroed = scale.weight === 0;
  if (REACT_APP_ENABLE_MANUAL_WEIGHT_FOR_SALES === 'true') {
    if (scaleIsZeroed) {
      return false;
    }
    return true;
  }

  return !(scale.weight === 0 && returnMode);
};

export const getIsManualWeightDisabledForReturnItem = (scale: ScaleState) => {
  const { REACT_APP_ENABLE_MANUAL_WEIGHT_FOR_SALES } = ElectronHelper.isElectron()
    ? RetailElectronAPI.getEnvironmentVariables()
    : process.env;
  const scaleIsZeroed = scale.weight === 0;
  if (REACT_APP_ENABLE_MANUAL_WEIGHT_FOR_SALES === 'true') {
    if (scaleIsZeroed) {
      return false;
    }
  }
  return !scaleIsZeroed;
};
